import React, { useEffect, useState } from "react";
import { useApp } from "../../../hooks/app-context";
import { useConfig } from "../../../hooks/config-context";
import { AzureAdSsoButtonComponent } from "../shared/AzureAdSsoButtonComponent";
import { GoogleSsoButtonComponent } from "../shared/GoogleSsoButtonComponent";
import { LinkedinSsoButtonComponent } from "../shared/LinkedinSsoButtonComponent";
import { GithubSsoButtonComponent } from "../shared/GithubSsoButtonComponent";
import { AppleSsoButtonComponent } from "../shared/AppleSsoButtonComponent";
import { FacebookSsoButtonComponent } from "../shared/FacebookSsoButtonComponent";
const SsoButtonsComponent = ({
  didClickSsoBtn,
  label,
  hasAlternatives,
  forceFederation
}) => {
  const {
    authLegacy
  } = useConfig();
  const [_hasAlternatives, _setHasAlternatives] = useState(false);
  const {
    azureAdSsoEnabled,
    googleSsoEnabled,
    linkedinSsoEnabled,
    facebookSsoEnabled,
    githubSsoEnabled,
    appleSsoEnabled
  } = useApp();

  // Show SSO Login btn if we have it enabled
  const azureAdLogin = !authLegacy && azureAdSsoEnabled && (label != "continue" || forceFederation === "ms-azure-ad");
  const googleLogin = !authLegacy && googleSsoEnabled && (label != "continue" || forceFederation === "google");
  const facebookLogin = !authLegacy && facebookSsoEnabled && (label != "continue" || forceFederation === "facebook");
  const appleLogin = !authLegacy && appleSsoEnabled && (label != "continue" || forceFederation === "apple");
  const githubLogin = !authLegacy && githubSsoEnabled && (label != "continue" || forceFederation === "github");
  const linkedinLogin = !authLegacy && linkedinSsoEnabled && (label != "continue" || forceFederation === "linkedin");
  useEffect(() => {
    _setHasAlternatives(!!(azureAdLogin || googleLogin || facebookLogin || appleLogin || githubLogin || linkedinLogin));
  }, [azureAdLogin, googleLogin, facebookLogin, appleLogin, githubLogin, linkedinLogin]);
  useEffect(() => {
    if (hasAlternatives) hasAlternatives(_hasAlternatives);
  }, [_hasAlternatives]);
  const renderAzureAd = () => {
    if (azureAdLogin) {
      return /*#__PURE__*/React.createElement(AzureAdSsoButtonComponent, {
        label: label,
        onClick: () => didClickSsoBtn("ms-azure-ad")
      });
    }
  };
  const renderGoogle = () => {
    if (googleLogin) {
      return /*#__PURE__*/React.createElement(GoogleSsoButtonComponent, {
        label: label,
        onClick: () => didClickSsoBtn("google")
      });
    }
  };
  const renderFacebook = () => {
    if (facebookLogin) {
      return /*#__PURE__*/React.createElement(FacebookSsoButtonComponent, {
        label: label,
        onClick: () => didClickSsoBtn("facebook")
      });
    }
  };
  const renderApple = () => {
    if (appleLogin) {
      return /*#__PURE__*/React.createElement(AppleSsoButtonComponent, {
        label: label,
        onClick: () => didClickSsoBtn("apple")
      });
    }
  };
  const renderGithub = () => {
    if (githubLogin) {
      return /*#__PURE__*/React.createElement(GithubSsoButtonComponent, {
        label: label,
        onClick: () => didClickSsoBtn("github")
      });
    }
  };
  const renderLinkedin = () => {
    if (linkedinLogin) {
      return /*#__PURE__*/React.createElement(LinkedinSsoButtonComponent, {
        label: label,
        onClick: () => didClickSsoBtn("linkedin")
      });
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, renderGoogle(), renderAzureAd(), renderApple(), renderFacebook(), renderGithub(), renderLinkedin());
};
export { SsoButtonsComponent };